document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.review-section__item');
  const button = document.querySelector('.review-section__button');
  const step = 3;
  let visibleCount = 3;

  items.forEach((item, index) => {
    if (index < visibleCount) {
      item.classList.add('is-visible');
    }
  });

  button?.addEventListener('click', (e) => {
    e.preventDefault();

    const nextItems = Array.from(items).slice(visibleCount, visibleCount + step);
    nextItems.forEach(item => item.classList.add('is-visible'));

    visibleCount += step;

    if (visibleCount >= items.length) {
      button.style.display = 'none';
    }
  });
});
